
import Cell from 'vux/src/components/cell/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

export default{
components: {
Cell,
Popup,
Checklist,
Radio,
Flexbox,
FlexboxItem
},
props: {
title: String,
value: [String, Number, Array],
isLink: {
type: Boolean,
default: true
},
data: {
type: Array,
required: true
},
isMuti: {
type: Boolean,
default: false
},
isSearch: {
type: Boolean,
default: false
},
isShowCell: {
type: Boolean,
default: true
},
placeholder: {
type: String,
default: '请输入关键字'
}
},
data () {
return {
popup: false,
search_word: '',
result: '请选择',
currentValue: this.value
}
},
watch: {
value (val) {
this.currentValue = val
},
currentValue (val){
this.$emit('input',val)
this.$emit('on-change',val)

if(this.isSearch){
let obj = this.data.find(d=>d.key==val)
if(obj){
this.search_word = obj.value
}
}
}
},
methods: {
onHide (bool){
if(bool){
this.$emit('on-ok',this.getResult())
this.popup = false
}
else{
this.popup = false
}
},
getResult () {
let [result,currentValue] = [null,this.currentValue]
if(this.filter_data.length === 0){
result = this.search_word
}else{
result = currentValue
}
return result
}
},
computed: {
filter_data () {
if(this.search_word !== ''){
return this.data.filter(d=>d.value.indexOf(this.search_word)>-1)
}
return this.data
},
get_value () {
let filter = this.data.find(d=>d.key===this.currentValue)
let result = this.search_word
if(typeof filter !== 'undefined'){
result = filter.value
}
return result
}
}
}



// WEBPACK FOOTER //
// ./src/components/PopupPicker.vue